
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWaypointOptionalFilled as ObiWaypointOptionalFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-waypoint-optional-filled.js';
 
 
 

 
 export const ObiWaypointOptionalFilled = createComponent({
   react: React,
   tagName: 'obi-waypoint-optional-filled',
   elementClass: ObiWaypointOptionalFilledElement,
   events: {
     
   }
  });
 
 